import MakerPage from "../../components/makerPage/MakerPage";
import {iconsImage} from "../../components/menu/IconMenu"

import { useTranslation } from "react-i18next";
import ProjectItem from "../../components/projectItem/ProjectItem";

//import images
import {imgContent } from "../../components/projectItem/ProjectIcons"


import ReactJSTag from "../../components/tag/listTag/ReactJSTag";
import PythonTag from "../../components/tag/listTag/PythonTag";
import AngularTag from "../../components/tag/listTag/AngularTag";
import ArduinoTag from "../../components/tag/listTag/ArduinoTag";
import GodotTag from "../../components/tag/listTag/GodotTag";
import UnityTag from "../../components/tag/listTag/UnityTag";
import MultPratformTag, {WindowsTag, MacTag} from "../../components/tag/listTag/MultPlatformTag";
import Love2dTag from "../../components/tag/listTag/Love2DTag";

export default function Projects(props) {
  const {t} = useTranslation()

  return (
    <MakerPage index={props.index} title={t('projects')} iconPath={iconsImage.projectIcon} >

			<ProjectItem index={1} link="https://github.com/ViniZap4/Vortex-Notation" name="Dog Adventure" img={imgContent.ZeldaProject} description={t('Dog-Adventure-description')}  tags={<UnityTag />} />
			<ProjectItem index={2} link="https://dog-adventure-landing-page.vercel.app/" name="Landing Page - Dog Adventure" img={imgContent.LandingPageDogAdventure} description={t('Dog-Adventure-landing-page-description')}  tags={<AngularTag />} />
			<ProjectItem index={3} link="https://vinizap.itch.io/infinityway" name="InfinityWay" img={imgContent.InfinityWay} description={t('infinityWay-description')}  tags={<><UnityTag /><MultPratformTag /></>} />
			<ProjectItem index={4} link="https://block-breaker-game.vercel.app" name="Block Braker" img={imgContent.blockBraker} description={t('block-breaker-description')}  tags={<GodotTag />} />
			<ProjectItem index={5} link="https://vinizap.itch.io/pong" name="Pong" img={imgContent.Pong} description={t('pong-description')}  tags={<><Love2dTag /><MacTag /><WindowsTag /> </>} />
			<ProjectItem index={6} link="https://github.com/ViniZap4/fifty-Bird" name="Fifty Bird" img={imgContent.FiftBird} description={t('fift-bird-description')}  tags={<Love2dTag />} />

			<ProjectItem index={7} link="https://github.com/ViniZap4/garraRobo-arduino-joysticks" name="Robot Claw" img={imgContent.RobotClaw} description={t('robot-claw-description')} tags={<ArduinoTag />}/>
			{/*<ProjectItem index={7} link="https://github.com/ViniZap4/Climate-Action-Tracker-CAT" name="Emissão de CO2" img={imgContent.EmissionCO2} description={t('emission-CO2-description')} tags={<PythonTag />}/>*/}
      <ProjectItem index={8} link="https://connect-developers-articles.vercel.app/" name="Connect Developers" img={imgContent.connectDevelopers} description={t('connect-developers-description')} tags={<ReactJSTag />}/>

    </MakerPage>
  );
}